<template>
  <div class="tokyo_tm_about modern-about">
    <div class="about_image modern-about-image">
      <img src="../assets/img/portfolio/1.jpg" alt="about" />
    </div>

    <div class="description">
      <h3 class="name">Touch Designs - Since 2005</h3>
      <div class="description_inner">
        <div class="left">
          <p>
            Touch Designs is a boutique interior design service and resource supply company, passionate about 
            creativity and cutting edge design for the residential and 
            commercial spaces.
            
          </p>
          <hr>
           <p>
            In our drive to deliver innovative and practical solutions to our
            customers, we utilize years experience in interior design, interior finishes and furniture supplies including project management.
          </p>
          <hr>
           <p>
            Our strength lies in our passion for creativity, bringing unique
            elements to both modern and traditional designs. We take pride in designing and planning environments that are
            ergonomic and welcoming. We aim to ensure that our customers enjoy the spaces created.
          </p>
          <div class="tokyo_tm_button">
            <button class="ib-button" @click="showModal">Read More</button>
          </div>
        </div>
        <!-- End .left -->

        <div class="right">
          <ul>
            <li>
              <p><span>Contact:</span>Tsitsi Mpofu</p>
            </li>
            <li>
              <p>
                <span>Email:</span
                ><a href="mailto:tsitsimpofu@touchdesigns.co.zw">tsitsimpofu@touchdesigns.co.zw</a>
              </p>
            </li>
            <li>
              <p>
                <span>Phone:</span
                ><a href="tel:+263772877474">+263 772 877 474</a>
              </p>
            </li>
            <li>
              <p><span>Address:</span>42 Nelson	Mandela Street Harare
              </p>
            </li>
            <li>
              <p><span>Country:</span>Zimbabwe</p>
            </li>
          </ul>
          <!-- End ul -->
        </div>
        <!-- End .right -->
      </div>
    </div>

    <!-- Start Modalbox -->
    <transition name="fade">
      <!-- Modal -->
      <div
        :class="{ 'modal-mask': isActive }"
        id="modal"
        @click="closeModal"
        v-if="isVisible"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-user"
          @click.stop
        >
          <div class="modal-content">
            <div class="tokyo_tm_modalbox_about">
              <div class="close" @click="closeModal">
                <img
                  class="svg"
                  src="../assets/img/svg/cancel.svg"
                  alt="cancel-img"
                />
              </div>
              <!-- End .close -->
              <div class="my_box">
                <div class="left">
                  <div class="about_title">
                    <h3>Project pipeline</h3>
                  </div>
                  <!-- End .abut_title -->
                  <div class="tokyo_progress">
                    <div class="progress_inner">
                      <span
                        ><span class="label">First Meeting</span
                        ><span class="number">5%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:5%"></div>
                        </div>
                      </div>
                    </div>
                    <!-- End progress_inner -->
                    <div class="progress_inner">
                      <span
                        ><span class="label">Initial Phase</span
                        ><span class="number">15%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:15%"></div>
                        </div>
                      </div>
                    </div>
                    <!-- End progress_inner -->
                    <div class="progress_inner">
                      <span
                        ><span class="label">Design Proposal</span
                        ><span class="number">40%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:40%"></div>
                        </div>
                      </div>
                    </div>
                    <!-- End progress_inner -->
                  </div>
                  <!-- End .tokyo_progress -->
                </div>
                <!-- End .left -->
                <div class="right">
                  <div class="about_title">
                    <h3> from 0 - 100%</h3>
                  </div>
                  <div class="tokyo_progress">
                    <div class="progress_inner">
                      <span
                        ><span class="label">Planning Phase</span
                        ><span class="number">70%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:70%"></div>
                        </div>
                      </div>
                    </div>
                    <div class="progress_inner">
                      <span
                        ><span class="label">Construction</span
                        ><span class="number">90%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:90%"></div>
                        </div>
                      </div>
                    </div>
                    <div class="progress_inner">
                      <span
                        ><span class="label">Move Management &amp; Handover</span
                        ><span class="number">100%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:100%"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End .right -->
              </div>
              <div class="counter">
                <div class="about_title">
                  <h3>Fun Facts</h3>
                </div>
                <ul>
                  <li>
                    <div class="list_inner">
                      <h3>777+</h3>
                      <span>Projects Completed</span>
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <h3>3K</h3>
                      <span>Happy Clients</span>
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <h3>100+</h3>
                      <span>Site Plans</span>
                    </div>
                  </li>
                </ul>
                <!-- End ul -->
              </div>
              <!-- End .counter -->
              <div class="partners">
                <div class="about_title">
                  <h3>Our Clients</h3>
                </div>
                <Brand />
              </div>
              <!-- End .partner -->
            </div>
            <!-- End .tokyo_tm_modalbox_about -->
          </div>
        </div>
      </div>
    </transition>
    <!-- End Modalbox -->
  </div>
</template>

<script>
import Brand from "./Brand";

export default {
  components: {
    Brand,
  },
  data() {
    return {
      isActive: false,
      isVisible: false,
    };
  },
  methods: {
    showModal: function() {
      this.isActive = true;
      this.isVisible = true;
    },
    closeModal: function() {
      this.isActive = false;
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modern-about {
  .modern-about-image {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    margin-bottom: 40px;
    transition: transform 0.4s ease;

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .description {
    .name {
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 24px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    p {
      line-height: 1.8;
      color: #555;
      margin-bottom: 20px;
    }

    hr {
      border: none;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.3), transparent);
      margin: 24px 0;
    }

    .tokyo_tm_button {
      margin-top: 32px;

      .ib-button {
        padding: 14px 32px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border: none;
        border-radius: 30px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }
      }
    }

    .right ul li {
      margin-bottom: 16px;
      padding: 12px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      p {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 12px;

        span {
          font-weight: 600;
          color: #667eea;
          min-width: 80px;
        }

        a {
          color: #555;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: #667eea;
          }
        }
      }
    }
  }
}

.dark {
  .modern-about {
    .description {
      p {
        color: #aaa;
      }

      .right ul li {
        border-bottom-color: rgba(255, 255, 255, 0.1);

        p a {
          color: #aaa;

          &:hover {
            color: #8b9cff;
          }
        }
      }
    }
  }
}
</style>
